import React from 'react'
import TypingEffect2 from '../Organizers/typingEffect2'
import "./speakers.css"

const speakers = () => {
    const text = "GUESTS";
    
  return (
    <div className='Outside'>
    <h3 className='ubuntu-bold' style={{fontSize:"50px",textAlign:"center", marginBottom:"70px"}}> ESTEEMED <TypingEffect2 text={text} speed={50} /></h3>
    <section class="articless">
  <article>
    <div class="article-wrapper">
      <figure>
        <img src="https://as1.ftcdn.net/v2/jpg/05/58/20/28/1000_F_558202843_OKjb5BSDd2vkRloCScoTH9wdjTglnoFk.jpg" alt="" />
      </figure>
      <div class="article-body">
        <h2 className='ubuntu-regular'>Yet to be revealed</h2>
        <p>
          Curabitur convallis ac quam vitae laoreet. Nulla mauris ante, euismod sed lacus sit amet, congue bibendum eros. Etiam mattis lobortis porta. Vestibulum ultrices iaculis enim imperdiet egestas.
        </p>
        <a href="/" class="read-more">
          LinkedIn
          <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </a>
      </div>
    </div>
  </article>
  <article>
    <div class="article-wrapper">
      <figure>
        <img src="https://as1.ftcdn.net/v2/jpg/05/58/20/28/1000_F_558202843_OKjb5BSDd2vkRloCScoTH9wdjTglnoFk.jpg" alt="" />
      </figure>
      <div class="article-body">
        <h2 className='ubuntu-regular'>Yet to be revealed</h2>
        <p>
          Curabitur convallis ac quam vitae laoreet. Nulla mauris ante, euismod sed lacus sit amet, congue bibendum eros. Etiam mattis lobortis porta. Vestibulum ultrices iaculis enim imperdiet egestas.
        </p>
        <a href="#" class="read-more">
          LinkedIn
          <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </a>
      </div>
    </div>
  </article>
  <article>
    <div class="article-wrapper">
      <figure>
        <img src="https://as1.ftcdn.net/v2/jpg/05/58/20/28/1000_F_558202843_OKjb5BSDd2vkRloCScoTH9wdjTglnoFk.jpg" alt="" />
      </figure>
      <div class="article-body">
        <h2 className='ubuntu-regular'>Yet to be revealed</h2>
        <p>
          Curabitur convallis ac quam vitae laoreet. Nulla mauris ante, euismod sed lacus sit amet, congue bibendum eros. Etiam mattis lobortis porta. Vestibulum ultrices iaculis enim imperdiet egestas.
        </p>
        <a href="#" class="read-more">
          LinkedIn
          <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </a>
      </div>
    </div>
  </article>
  <article>
    <div class="article-wrapper">
      <figure>
        <img src="https://as1.ftcdn.net/v2/jpg/05/58/20/28/1000_F_558202843_OKjb5BSDd2vkRloCScoTH9wdjTglnoFk.jpg" alt="" />
      </figure>
      <div class="article-body">
        <h2 className='ubuntu-regular'>Yet to be revealed</h2>
        <p>
          Curabitur convallis ac quam vitae laoreet. Nulla mauris ante, euismod sed lacus sit amet, congue bibendum eros. Etiam mattis lobortis porta. Vestibulum ultrices iaculis enim imperdiet egestas.
        </p>
        <a href="#" class="read-more">
          LinkedIn
          <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </a>
      </div>
    </div>
  </article>
  <article>
    <div class="article-wrapper">
      <figure>
        <img src="https://as1.ftcdn.net/v2/jpg/05/58/20/28/1000_F_558202843_OKjb5BSDd2vkRloCScoTH9wdjTglnoFk.jpg" alt="" />
      </figure>
      <div class="article-body">
        <h2 className='ubuntu-regular'>Yet to be revealed</h2>
        <p>
          Curabitur convallis ac quam vitae laoreet. Nulla mauris ante, euismod sed lacus sit amet, congue bibendum eros. Etiam mattis lobortis porta. Vestibulum ultrices iaculis enim imperdiet egestas.
        </p>
        <a href="#" class="read-more">
          LinkedIn
          <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </a>
      </div>
    </div>
  </article>
  <article>

    <div class="article-wrapper">
      <figure>
        <img src="https://as1.ftcdn.net/v2/jpg/05/58/20/28/1000_F_558202843_OKjb5BSDd2vkRloCScoTH9wdjTglnoFk.jpg" alt="" />
      </figure>
      <div class="article-body">
        <h2 className='ubuntu-regular'>Yet to be revealed</h2>
        <p>
          Curabitur convallis ac quam vitae laoreet. Nulla mauris ante, euismod sed lacus sit amet, congue bibendum eros. Etiam mattis lobortis porta. Vestibulum ultrices iaculis enim imperdiet egestas.
        </p>
        <a href="https://www.linkedin.com/in/khushi-mittal-21b3ba246/" class="read-more">
          LinkedIn 
          <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </a>
      </div>
    </div>
  </article>
</section>

      
    </div>
  )
}

export default speakers
